import { ELanguage } from '@smartshell/ui-kit';

export const LINKS = {
  features: {
    booking: {
      [ELanguage.RU]:
        'https://support.smartshell.gg/hc/ru/articles/13067169893005',
      [ELanguage.KK]:
        'https://support.smartshell.gg/hc/ru/articles/13067169893005',
      [ELanguage.UZ]:
        'https://support.smartshell.gg/hc/ru/articles/13067169893005',
      [ELanguage.KY]:
        'https://support.smartshell.gg/hc/ru/articles/13067169893005',
      [ELanguage.AZ]:
        'https://support.smartshell.gg/hc/ru/articles/13067169893005',
      [ELanguage.EN]:
        'https://support.smartshell.gg/hc/en-us/articles/13067169893005',
      [ELanguage.VI]:
        'https://support.smartshell.gg/hc/en-us/articles/13067169893005',
      [ELanguage.ES]:
        'https://support.smartshell.gg/hc/en-us/articles/13067169893005',
      [ELanguage.PT]:
        'https://support.smartshell.gg/hc/en-us/articles/13067169893005',
      [ELanguage.FR]:
        'https://support.smartshell.gg/hc/en-us/articles/13067169893005',
      [ELanguage.TR]:
        'https://support.smartshell.gg/hc/en-us/articles/13067169893005',
      [ELanguage.DE]:
        'https://support.smartshell.gg/hc/en-us/articles/13067169893005',
    },
    sbp_tinkoff: {
      [ELanguage.RU]:
        'https://support.smartshell.gg/hc/ru/sections/21315541771661',
      [ELanguage.KK]:
        'https://support.smartshell.gg/hc/ru/sections/21315541771661',
      [ELanguage.UZ]:
        'https://support.smartshell.gg/hc/ru/sections/21315541771661',
      [ELanguage.KY]:
        'https://support.smartshell.gg/hc/ru/sections/21315541771661',
      [ELanguage.AZ]:
        'https://support.smartshell.gg/hc/ru/sections/21315541771661',
      [ELanguage.EN]:
        'https://support.smartshell.gg/hc/en-us/sections/21315541771661',
      [ELanguage.VI]:
        'https://support.smartshell.gg/hc/en-us/sections/21315541771661',
      [ELanguage.ES]:
        'https://support.smartshell.gg/hc/en-us/sections/21315541771661',
      [ELanguage.PT]:
        'https://support.smartshell.gg/hc/en-us/sections/21315541771661',
      [ELanguage.FR]:
        'https://support.smartshell.gg/hc/en-us/sections/21315541771661',
      [ELanguage.TR]:
        'https://support.smartshell.gg/hc/en-us/sections/21315541771661',
      [ELanguage.DE]:
        'https://support.smartshell.gg/hc/en-us/sections/21315541771661',
    },
    combos: {
      [ELanguage.RU]:
        'https://support.smartshell.gg/hc/ru/articles/23730853399693',
      [ELanguage.KK]:
        'https://support.smartshell.gg/hc/ru/articles/23730853399693',
      [ELanguage.UZ]:
        'https://support.smartshell.gg/hc/ru/articles/23730853399693',
      [ELanguage.KY]:
        'https://support.smartshell.gg/hc/ru/articles/23730853399693',
      [ELanguage.AZ]:
        'https://support.smartshell.gg/hc/ru/articles/23730853399693',
      [ELanguage.EN]:
        'https://support.smartshell.gg/hc/en-us/articles/23730853399693',
      [ELanguage.VI]:
        'https://support.smartshell.gg/hc/en-us/articles/23730853399693',
      [ELanguage.ES]:
        'https://support.smartshell.gg/hc/en-us/articles/23730853399693',
      [ELanguage.PT]:
        'https://support.smartshell.gg/hc/en-us/articles/23730853399693',
      [ELanguage.FR]:
        'https://support.smartshell.gg/hc/en-us/articles/23730853399693',
      [ELanguage.TR]:
        'https://support.smartshell.gg/hc/en-us/articles/23730853399693',
      [ELanguage.DE]:
        'https://support.smartshell.gg/hc/en-us/articles/23730853399693',
    },
    bonus_cash: {
      [ELanguage.RU]:
        'https://support.smartshell.gg/hc/ru/articles/18510089834381',
      [ELanguage.KK]:
        'https://support.smartshell.gg/hc/ru/articles/18510089834381',
      [ELanguage.UZ]:
        'https://support.smartshell.gg/hc/ru/articles/18510089834381',
      [ELanguage.KY]:
        'https://support.smartshell.gg/hc/ru/articles/18510089834381',
      [ELanguage.AZ]:
        'https://support.smartshell.gg/hc/ru/articles/18510089834381',
      [ELanguage.EN]:
        'https://support.smartshell.gg/hc/en-us/articles/18510089834381',
      [ELanguage.VI]:
        'https://support.smartshell.gg/hc/en-us/articles/18510089834381',
      [ELanguage.ES]:
        'https://support.smartshell.gg/hc/en-us/articles/18510089834381',
      [ELanguage.PT]:
        'https://support.smartshell.gg/hc/en-us/articles/18510089834381',
      [ELanguage.FR]:
        'https://support.smartshell.gg/hc/en-us/articles/18510089834381',
      [ELanguage.TR]:
        'https://support.smartshell.gg/hc/en-us/articles/18510089834381',
      [ELanguage.DE]:
        'https://support.smartshell.gg/hc/en-us/articles/18510089834381',
    },
    game_accounts_widget: {
      [ELanguage.RU]:
        'https://support.smartshell.gg/hc/ru/articles/10935198764813',
      [ELanguage.KK]:
        'https://support.smartshell.gg/hc/ru/articles/10935198764813',
      [ELanguage.UZ]:
        'https://support.smartshell.gg/hc/ru/articles/10935198764813',
      [ELanguage.KY]:
        'https://support.smartshell.gg/hc/ru/articles/10935198764813',
      [ELanguage.AZ]:
        'https://support.smartshell.gg/hc/ru/articles/10935198764813',
      [ELanguage.EN]:
        'https://support.smartshell.gg/hc/en-us/articles/10935198764813',
      [ELanguage.VI]:
        'https://support.smartshell.gg/hc/en-us/articles/10935198764813',
      [ELanguage.ES]:
        'https://support.smartshell.gg/hc/en-us/articles/10935198764813',
      [ELanguage.PT]:
        'https://support.smartshell.gg/hc/en-us/articles/10935198764813',
      [ELanguage.FR]:
        'https://support.smartshell.gg/hc/en-us/articles/10935198764813',
      [ELanguage.TR]:
        'https://support.smartshell.gg/hc/en-us/articles/10935198764813',
      [ELanguage.DE]:
        'https://support.smartshell.gg/hc/en-us/articles/10935198764813',
    },
    activity_rating: {
      [ELanguage.RU]:
        'https://support.smartshell.gg/hc/ru/articles/10934957141901',
      [ELanguage.KK]:
        'https://support.smartshell.gg/hc/ru/articles/10934957141901',
      [ELanguage.UZ]:
        'https://support.smartshell.gg/hc/ru/articles/10934957141901',
      [ELanguage.KY]:
        'https://support.smartshell.gg/hc/ru/articles/10934957141901',
      [ELanguage.AZ]:
        'https://support.smartshell.gg/hc/ru/articles/10934957141901',
      [ELanguage.EN]:
        'https://support.smartshell.gg/hc/en-us/articles/10934957141901',
      [ELanguage.VI]:
        'https://support.smartshell.gg/hc/en-us/articles/10934957141901',
      [ELanguage.ES]:
        'https://support.smartshell.gg/hc/en-us/articles/10934957141901',
      [ELanguage.PT]:
        'https://support.smartshell.gg/hc/en-us/articles/10934957141901',
      [ELanguage.FR]:
        'https://support.smartshell.gg/hc/en-us/articles/10934957141901',
      [ELanguage.TR]:
        'https://support.smartshell.gg/hc/en-us/articles/10934957141901',
      [ELanguage.DE]:
        'https://support.smartshell.gg/hc/en-us/articles/10934957141901',
    },
    club_news: {
      [ELanguage.RU]:
        'https://support.smartshell.gg/hc/ru/articles/13067169893005',
      [ELanguage.KK]:
        'https://support.smartshell.gg/hc/ru/articles/13067169893005',
      [ELanguage.UZ]:
        'https://support.smartshell.gg/hc/ru/articles/13067169893005',
      [ELanguage.KY]:
        'https://support.smartshell.gg/hc/ru/articles/13067169893005',
      [ELanguage.AZ]:
        'https://support.smartshell.gg/hc/ru/articles/13067169893005',
      [ELanguage.EN]:
        'https://support.smartshell.gg/hc/en-us/articles/13067169893005',
      [ELanguage.VI]:
        'https://support.smartshell.gg/hc/en-us/articles/13067169893005',
      [ELanguage.ES]:
        'https://support.smartshell.gg/hc/en-us/articles/13067169893005',
      [ELanguage.PT]:
        'https://support.smartshell.gg/hc/en-us/articles/13067169893005',
      [ELanguage.FR]:
        'https://support.smartshell.gg/hc/en-us/articles/13067169893005',
      [ELanguage.TR]:
        'https://support.smartshell.gg/hc/en-us/articles/13067169893005',
      [ELanguage.DE]:
        'https://support.smartshell.gg/hc/en-us/articles/13067169893005',
    },
    copy_settings: {
      [ELanguage.RU]:
        'https://support.smartshell.gg/hc/ru/articles/43467569894285',
      [ELanguage.KK]:
        'https://support.smartshell.gg/hc/ru/articles/43467569894285',
      [ELanguage.UZ]:
        'https://support.smartshell.gg/hc/ru/articles/43467569894285',
      [ELanguage.KY]:
        'https://support.smartshell.gg/hc/ru/articles/43467569894285',
      [ELanguage.AZ]:
        'https://support.smartshell.gg/hc/ru/articles/43467569894285',
      [ELanguage.EN]:
        'https://support.smartshell.gg/hc/en-us/articles/43467569894285',
      [ELanguage.VI]:
        'https://support.smartshell.gg/hc/en-us/articles/43467569894285',
      [ELanguage.ES]:
        'https://support.smartshell.gg/hc/en-us/articles/43467569894285',
      [ELanguage.PT]:
        'https://support.smartshell.gg/hc/en-us/articles/43467569894285',
      [ELanguage.FR]:
        'https://support.smartshell.gg/hc/en-us/articles/43467569894285',
      [ELanguage.TR]:
        'https://support.smartshell.gg/hc/en-us/articles/43467569894285',
      [ELanguage.DE]:
        'https://support.smartshell.gg/hc/en-us/articles/43467569894285',
    },
  },
  cash_orders: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/11214070549517',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/11214070549517',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/11214070549517',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/11214070549517',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/11214070549517',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/11214070549517',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/11214070549517',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/11214070549517',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/11214070549517',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/11214070549517',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/11214070549517',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/11214070549517',
  },
  stock_refill: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/28608860492301',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/28608860492301',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/28608860492301',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/28608860492301',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/28608860492301',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/28608860492301',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/28608860492301',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/28608860492301',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/28608860492301',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/28608860492301',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/28608860492301',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/28608860492301',
  },
  user_history: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPATZNVWZNWFT289VRHKTM',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPATZNVWZNWFT289VRHKTM',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPATZNVWZNWFT289VRHKTM',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPATZNVWZNWFT289VRHKTM',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPATZNVWZNWFT289VRHKTM',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPATZNVWZNWFT289VRHKTM',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPATZNVWZNWFT289VRHKTM',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPATZNVWZNWFT289VRHKTM',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPATZNVWZNWFT289VRHKTM',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPATZNVWZNWFT289VRHKTM',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPATZNVWZNWFT289VRHKTM',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPATZNVWZNWFT289VRHKTM',
  },
  user_comments: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPB1KPS74DRWPJKSYBNT3V',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPB1KPS74DRWPJKSYBNT3V',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPB1KPS74DRWPJKSYBNT3V',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPB1KPS74DRWPJKSYBNT3V',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPB1KPS74DRWPJKSYBNT3V',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPB1KPS74DRWPJKSYBNT3V',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPB1KPS74DRWPJKSYBNT3V',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPB1KPS74DRWPJKSYBNT3V',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPB1KPS74DRWPJKSYBNT3V',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPB1KPS74DRWPJKSYBNT3V',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPB1KPS74DRWPJKSYBNT3V',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/10935056179597-%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%9C%D0%B5%D0%BD%D0%B5%D0%B4%D0%B6%D0%B5%D1%80%D0%B0#h_01GJWPB1KPS74DRWPJKSYBNT3V',
  },
  discounts: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/10935114785677',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/10935114785677',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/10935114785677',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/10935114785677',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/10935114785677',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677',
  },
  base_reports: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/23681229437325-%D0%9E%D0%B1%D0%B7%D0%BE%D1%80%D0%BD%D1%8B%D0%B9-%D0%BE%D1%82%D1%87%D0%B5%D1%82',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/23681229437325-%D0%9E%D0%B1%D0%B7%D0%BE%D1%80%D0%BD%D1%8B%D0%B9-%D0%BE%D1%82%D1%87%D0%B5%D1%82',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/23681229437325-%D0%9E%D0%B1%D0%B7%D0%BE%D1%80%D0%BD%D1%8B%D0%B9-%D0%BE%D1%82%D1%87%D0%B5%D1%82',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/23681229437325-%D0%9E%D0%B1%D0%B7%D0%BE%D1%80%D0%BD%D1%8B%D0%B9-%D0%BE%D1%82%D1%87%D0%B5%D1%82',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/23681229437325-%D0%9E%D0%B1%D0%B7%D0%BE%D1%80%D0%BD%D1%8B%D0%B9-%D0%BE%D1%82%D1%87%D0%B5%D1%82',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/23681229437325-%D0%9E%D0%B1%D0%B7%D0%BE%D1%80%D0%BD%D1%8B%D0%B9-%D0%BE%D1%82%D1%87%D0%B5%D1%82',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/23681229437325-%D0%9E%D0%B1%D0%B7%D0%BE%D1%80%D0%BD%D1%8B%D0%B9-%D0%BE%D1%82%D1%87%D0%B5%D1%82',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/23681229437325-%D0%9E%D0%B1%D0%B7%D0%BE%D1%80%D0%BD%D1%8B%D0%B9-%D0%BE%D1%82%D1%87%D0%B5%D1%82',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/23681229437325-%D0%9E%D0%B1%D0%B7%D0%BE%D1%80%D0%BD%D1%8B%D0%B9-%D0%BE%D1%82%D1%87%D0%B5%D1%82',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/23681229437325-%D0%9E%D0%B1%D0%B7%D0%BE%D1%80%D0%BD%D1%8B%D0%B9-%D0%BE%D1%82%D1%87%D0%B5%D1%82',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/23681229437325-%D0%9E%D0%B1%D0%B7%D0%BE%D1%80%D0%BD%D1%8B%D0%B9-%D0%BE%D1%82%D1%87%D0%B5%D1%82',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/23681229437325-%D0%9E%D0%B1%D0%B7%D0%BE%D1%80%D0%BD%D1%8B%D0%B9-%D0%BE%D1%82%D1%87%D0%B5%D1%82',
  },
  work_shift_reports: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/10935200920077-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D1%81%D0%BC%D0%B5%D0%BD%D0%B0%D0%BC#h_01GJWPZTESXX45PPQ9D4HFDCKS',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/10935200920077-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D1%81%D0%BC%D0%B5%D0%BD%D0%B0%D0%BC#h_01GJWPZTESXX45PPQ9D4HFDCKS',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/10935200920077-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D1%81%D0%BC%D0%B5%D0%BD%D0%B0%D0%BC#h_01GJWPZTESXX45PPQ9D4HFDCKS',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/10935200920077-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D1%81%D0%BC%D0%B5%D0%BD%D0%B0%D0%BC#h_01GJWPZTESXX45PPQ9D4HFDCKS',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/10935200920077-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D1%81%D0%BC%D0%B5%D0%BD%D0%B0%D0%BC#h_01GJWPZTESXX45PPQ9D4HFDCKS',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/10935200920077-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D1%81%D0%BC%D0%B5%D0%BD%D0%B0%D0%BC#h_01GJWPZTESXX45PPQ9D4HFDCKS',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/10935200920077-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D1%81%D0%BC%D0%B5%D0%BD%D0%B0%D0%BC#h_01GJWPZTESXX45PPQ9D4HFDCKS',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/10935200920077-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D1%81%D0%BC%D0%B5%D0%BD%D0%B0%D0%BC#h_01GJWPZTESXX45PPQ9D4HFDCKS',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/10935200920077-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D1%81%D0%BC%D0%B5%D0%BD%D0%B0%D0%BC#h_01GJWPZTESXX45PPQ9D4HFDCKS',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/10935200920077-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D1%81%D0%BC%D0%B5%D0%BD%D0%B0%D0%BC#h_01GJWPZTESXX45PPQ9D4HFDCKS',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/10935200920077-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D1%81%D0%BC%D0%B5%D0%BD%D0%B0%D0%BC#h_01GJWPZTESXX45PPQ9D4HFDCKS',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/10935200920077-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D1%81%D0%BC%D0%B5%D0%BD%D0%B0%D0%BC#h_01GJWPZTESXX45PPQ9D4HFDCKS',
  },
  auto_per_minute: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/17927639524749',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/17927639524749',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/17927639524749',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/17927639524749',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/17927639524749',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749',
  },
  pc_disk_hide: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/17927616748173',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/17927616748173',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/17927616748173',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/17927616748173',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/17927616748173',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/17927616748173',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/17927616748173',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/17927616748173',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/17927616748173',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/17927616748173',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/17927616748173',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/17927616748173',
  },
  autostart: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/17927625338125',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/17927625338125',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/17927625338125',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/17927625338125',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/17927625338125',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/17927625338125',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/17927625338125',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/17927625338125',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/17927625338125',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/17927625338125',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/17927625338125',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/17927625338125',
  },
  telegram_notify: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/11020163408653',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/11020163408653',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/11020163408653',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/11020163408653',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/11020163408653',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/11020163408653',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/11020163408653',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/11020163408653',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/11020163408653',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/11020163408653',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/11020163408653',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/11020163408653',
  },
  bonus_cash: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/11214609466893',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/11214609466893',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/11214609466893',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/11214609466893',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/11214609466893',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/11214609466893',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/11214609466893',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/11214609466893',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/11214609466893',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/11214609466893',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/11214609466893',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/11214609466893',
  },
  booking: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/17927639524749',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/17927639524749',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/17927639524749',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/17927639524749',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/17927639524749',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749',
  },
  cash_box: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/11055725620621',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/11055725620621',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/11055725620621',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/11055725620621',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/11055725620621',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/11055725620621',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/11055725620621',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/11055725620621',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/11055725620621',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/11055725620621',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/11055725620621',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/11055725620621',
  },
  deposit_cashback: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
  },
  achievements: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/10935114785677-%D0%A1%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0-%D0%BB%D0%BE%D1%8F%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8#h_01GTVQ66WG9E0NBZVSFZR91KDB',
  },
  ai_tariffs: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/17927639524749#:~:text=%D0%90%D0%B2%D1%82%D0%BE%D0%BC%D0%B0%D1%82%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%BE%D0%B5%20%D0%BF%D1%80%D0%BE%D0%B4%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5%20%D1%81%D0%B5%D1%81%D1%81%D0%B8%D0%B8,%D1%83%D1%87%D1%91%D1%82%D0%BD%D0%BE%D0%B9%20%D0%B7%D0%B0%D0%BF%D0%B8%D1%81%D0%B8%20%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/17927639524749#:~:text=%D0%90%D0%B2%D1%82%D0%BE%D0%BC%D0%B0%D1%82%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%BE%D0%B5%20%D0%BF%D1%80%D0%BE%D0%B4%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5%20%D1%81%D0%B5%D1%81%D1%81%D0%B8%D0%B8,%D1%83%D1%87%D1%91%D1%82%D0%BD%D0%BE%D0%B9%20%D0%B7%D0%B0%D0%BF%D0%B8%D1%81%D0%B8%20%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/17927639524749#:~:text=%D0%90%D0%B2%D1%82%D0%BE%D0%BC%D0%B0%D1%82%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%BE%D0%B5%20%D0%BF%D1%80%D0%BE%D0%B4%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5%20%D1%81%D0%B5%D1%81%D1%81%D0%B8%D0%B8,%D1%83%D1%87%D1%91%D1%82%D0%BD%D0%BE%D0%B9%20%D0%B7%D0%B0%D0%BF%D0%B8%D1%81%D0%B8%20%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/17927639524749#:~:text=%D0%90%D0%B2%D1%82%D0%BE%D0%BC%D0%B0%D1%82%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%BE%D0%B5%20%D0%BF%D1%80%D0%BE%D0%B4%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5%20%D1%81%D0%B5%D1%81%D1%81%D0%B8%D0%B8,%D1%83%D1%87%D1%91%D1%82%D0%BD%D0%BE%D0%B9%20%D0%B7%D0%B0%D0%BF%D0%B8%D1%81%D0%B8%20%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/17927639524749#:~:text=%D0%90%D0%B2%D1%82%D0%BE%D0%BC%D0%B0%D1%82%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%BE%D0%B5%20%D0%BF%D1%80%D0%BE%D0%B4%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5%20%D1%81%D0%B5%D1%81%D1%81%D0%B8%D0%B8,%D1%83%D1%87%D1%91%D1%82%D0%BD%D0%BE%D0%B9%20%D0%B7%D0%B0%D0%BF%D0%B8%D1%81%D0%B8%20%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749#:~:text=%D0%90%D0%B2%D1%82%D0%BE%D0%BC%D0%B0%D1%82%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%BE%D0%B5%20%D0%BF%D1%80%D0%BE%D0%B4%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5%20%D1%81%D0%B5%D1%81%D1%81%D0%B8%D0%B8,%D1%83%D1%87%D1%91%D1%82%D0%BD%D0%BE%D0%B9%20%D0%B7%D0%B0%D0%BF%D0%B8%D1%81%D0%B8%20%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749#:~:text=%D0%90%D0%B2%D1%82%D0%BE%D0%BC%D0%B0%D1%82%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%BE%D0%B5%20%D0%BF%D1%80%D0%BE%D0%B4%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5%20%D1%81%D0%B5%D1%81%D1%81%D0%B8%D0%B8,%D1%83%D1%87%D1%91%D1%82%D0%BD%D0%BE%D0%B9%20%D0%B7%D0%B0%D0%BF%D0%B8%D1%81%D0%B8%20%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749#:~:text=%D0%90%D0%B2%D1%82%D0%BE%D0%BC%D0%B0%D1%82%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%BE%D0%B5%20%D0%BF%D1%80%D0%BE%D0%B4%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5%20%D1%81%D0%B5%D1%81%D1%81%D0%B8%D0%B8,%D1%83%D1%87%D1%91%D1%82%D0%BD%D0%BE%D0%B9%20%D0%B7%D0%B0%D0%BF%D0%B8%D1%81%D0%B8%20%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749#:~:text=%D0%90%D0%B2%D1%82%D0%BE%D0%BC%D0%B0%D1%82%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%BE%D0%B5%20%D0%BF%D1%80%D0%BE%D0%B4%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5%20%D1%81%D0%B5%D1%81%D1%81%D0%B8%D0%B8,%D1%83%D1%87%D1%91%D1%82%D0%BD%D0%BE%D0%B9%20%D0%B7%D0%B0%D0%BF%D0%B8%D1%81%D0%B8%20%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749#:~:text=%D0%90%D0%B2%D1%82%D0%BE%D0%BC%D0%B0%D1%82%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%BE%D0%B5%20%D0%BF%D1%80%D0%BE%D0%B4%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5%20%D1%81%D0%B5%D1%81%D1%81%D0%B8%D0%B8,%D1%83%D1%87%D1%91%D1%82%D0%BD%D0%BE%D0%B9%20%D0%B7%D0%B0%D0%BF%D0%B8%D1%81%D0%B8%20%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749#:~:text=%D0%90%D0%B2%D1%82%D0%BE%D0%BC%D0%B0%D1%82%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%BE%D0%B5%20%D0%BF%D1%80%D0%BE%D0%B4%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5%20%D1%81%D0%B5%D1%81%D1%81%D0%B8%D0%B8,%D1%83%D1%87%D1%91%D1%82%D0%BD%D0%BE%D0%B9%20%D0%B7%D0%B0%D0%BF%D0%B8%D1%81%D0%B8%20%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/17927639524749#:~:text=%D0%90%D0%B2%D1%82%D0%BE%D0%BC%D0%B0%D1%82%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%BE%D0%B5%20%D0%BF%D1%80%D0%BE%D0%B4%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5%20%D1%81%D0%B5%D1%81%D1%81%D0%B8%D0%B8,%D1%83%D1%87%D1%91%D1%82%D0%BD%D0%BE%D0%B9%20%D0%B7%D0%B0%D0%BF%D0%B8%D1%81%D0%B8%20%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0',
  },
  self_host_change: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/14435316097037-%D0%9A%D0%B0%D0%BA-%D1%81%D0%B0%D0%BC%D0%BE%D1%81%D1%82%D0%BE%D1%8F%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D1%83-%D0%BF%D0%B5%D1%80%D0%B5%D1%81%D0%B5%D1%81%D1%82%D1%8C-%D0%B7%D0%B0-%D0%B4%D1%80%D1%83%D0%B3%D0%BE%D0%B9-%D0%9F%D0%9A-',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/14435316097037-%D0%9A%D0%B0%D0%BA-%D1%81%D0%B0%D0%BC%D0%BE%D1%81%D1%82%D0%BE%D1%8F%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D1%83-%D0%BF%D0%B5%D1%80%D0%B5%D1%81%D0%B5%D1%81%D1%82%D1%8C-%D0%B7%D0%B0-%D0%B4%D1%80%D1%83%D0%B3%D0%BE%D0%B9-%D0%9F%D0%9A-',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/14435316097037-%D0%9A%D0%B0%D0%BA-%D1%81%D0%B0%D0%BC%D0%BE%D1%81%D1%82%D0%BE%D1%8F%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D1%83-%D0%BF%D0%B5%D1%80%D0%B5%D1%81%D0%B5%D1%81%D1%82%D1%8C-%D0%B7%D0%B0-%D0%B4%D1%80%D1%83%D0%B3%D0%BE%D0%B9-%D0%9F%D0%9A-',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/14435316097037-%D0%9A%D0%B0%D0%BA-%D1%81%D0%B0%D0%BC%D0%BE%D1%81%D1%82%D0%BE%D1%8F%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D1%83-%D0%BF%D0%B5%D1%80%D0%B5%D1%81%D0%B5%D1%81%D1%82%D1%8C-%D0%B7%D0%B0-%D0%B4%D1%80%D1%83%D0%B3%D0%BE%D0%B9-%D0%9F%D0%9A-',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/14435316097037-%D0%9A%D0%B0%D0%BA-%D1%81%D0%B0%D0%BC%D0%BE%D1%81%D1%82%D0%BE%D1%8F%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D1%83-%D0%BF%D0%B5%D1%80%D0%B5%D1%81%D0%B5%D1%81%D1%82%D1%8C-%D0%B7%D0%B0-%D0%B4%D1%80%D1%83%D0%B3%D0%BE%D0%B9-%D0%9F%D0%9A-',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/14435316097037-%D0%9A%D0%B0%D0%BA-%D1%81%D0%B0%D0%BC%D0%BE%D1%81%D1%82%D0%BE%D1%8F%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D1%83-%D0%BF%D0%B5%D1%80%D0%B5%D1%81%D0%B5%D1%81%D1%82%D1%8C-%D0%B7%D0%B0-%D0%B4%D1%80%D1%83%D0%B3%D0%BE%D0%B9-%D0%9F%D0%9A-',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/14435316097037-%D0%9A%D0%B0%D0%BA-%D1%81%D0%B0%D0%BC%D0%BE%D1%81%D1%82%D0%BE%D1%8F%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D1%83-%D0%BF%D0%B5%D1%80%D0%B5%D1%81%D0%B5%D1%81%D1%82%D1%8C-%D0%B7%D0%B0-%D0%B4%D1%80%D1%83%D0%B3%D0%BE%D0%B9-%D0%9F%D0%9A-',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/14435316097037-%D0%9A%D0%B0%D0%BA-%D1%81%D0%B0%D0%BC%D0%BE%D1%81%D1%82%D0%BE%D1%8F%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D1%83-%D0%BF%D0%B5%D1%80%D0%B5%D1%81%D0%B5%D1%81%D1%82%D1%8C-%D0%B7%D0%B0-%D0%B4%D1%80%D1%83%D0%B3%D0%BE%D0%B9-%D0%9F%D0%9A-',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/14435316097037-%D0%9A%D0%B0%D0%BA-%D1%81%D0%B0%D0%BC%D0%BE%D1%81%D1%82%D0%BE%D1%8F%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D1%83-%D0%BF%D0%B5%D1%80%D0%B5%D1%81%D0%B5%D1%81%D1%82%D1%8C-%D0%B7%D0%B0-%D0%B4%D1%80%D1%83%D0%B3%D0%BE%D0%B9-%D0%9F%D0%9A-',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/14435316097037-%D0%9A%D0%B0%D0%BA-%D1%81%D0%B0%D0%BC%D0%BE%D1%81%D1%82%D0%BE%D1%8F%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D1%83-%D0%BF%D0%B5%D1%80%D0%B5%D1%81%D0%B5%D1%81%D1%82%D1%8C-%D0%B7%D0%B0-%D0%B4%D1%80%D1%83%D0%B3%D0%BE%D0%B9-%D0%9F%D0%9A-',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/14435316097037-%D0%9A%D0%B0%D0%BA-%D1%81%D0%B0%D0%BC%D0%BE%D1%81%D1%82%D0%BE%D1%8F%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D1%83-%D0%BF%D0%B5%D1%80%D0%B5%D1%81%D0%B5%D1%81%D1%82%D1%8C-%D0%B7%D0%B0-%D0%B4%D1%80%D1%83%D0%B3%D0%BE%D0%B9-%D0%9F%D0%9A-',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/14435316097037-%D0%9A%D0%B0%D0%BA-%D1%81%D0%B0%D0%BC%D0%BE%D1%81%D1%82%D0%BE%D1%8F%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D1%83-%D0%BF%D0%B5%D1%80%D0%B5%D1%81%D0%B5%D1%81%D1%82%D1%8C-%D0%B7%D0%B0-%D0%B4%D1%80%D1%83%D0%B3%D0%BE%D0%B9-%D0%9F%D0%9A-',
  },
  holiday_tariffs: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/26198628971533',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/26198628971533',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/26198628971533',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/26198628971533',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/26198628971533',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/26198628971533',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/26198628971533',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/26198628971533',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/26198628971533',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/26198628971533',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/26198628971533',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/26198628971533',
  },
  visits_report: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/17744008591501-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%9F%D0%BE%D1%81%D0%B5%D1%82%D0%B8%D1%82%D0%B5%D0%BB%D0%B8',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/17744008591501-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%9F%D0%BE%D1%81%D0%B5%D1%82%D0%B8%D1%82%D0%B5%D0%BB%D0%B8',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/17744008591501-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%9F%D0%BE%D1%81%D0%B5%D1%82%D0%B8%D1%82%D0%B5%D0%BB%D0%B8',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/17744008591501-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%9F%D0%BE%D1%81%D0%B5%D1%82%D0%B8%D1%82%D0%B5%D0%BB%D0%B8',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/17744008591501-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%9F%D0%BE%D1%81%D0%B5%D1%82%D0%B8%D1%82%D0%B5%D0%BB%D0%B8',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/17744008591501-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%9F%D0%BE%D1%81%D0%B5%D1%82%D0%B8%D1%82%D0%B5%D0%BB%D0%B8',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/17744008591501-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%9F%D0%BE%D1%81%D0%B5%D1%82%D0%B8%D1%82%D0%B5%D0%BB%D0%B8',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/17744008591501-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%9F%D0%BE%D1%81%D0%B5%D1%82%D0%B8%D1%82%D0%B5%D0%BB%D0%B8',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/17744008591501-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%9F%D0%BE%D1%81%D0%B5%D1%82%D0%B8%D1%82%D0%B5%D0%BB%D0%B8',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/17744008591501-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%9F%D0%BE%D1%81%D0%B5%D1%82%D0%B8%D1%82%D0%B5%D0%BB%D0%B8',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/17744008591501-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%9F%D0%BE%D1%81%D0%B5%D1%82%D0%B8%D1%82%D0%B5%D0%BB%D0%B8',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/17744008591501-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%9F%D0%BE%D1%81%D0%B5%D1%82%D0%B8%D1%82%D0%B5%D0%BB%D0%B8',
  },
  usage_report: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/17744048663181-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%97%D0%B0%D0%BD%D1%8F%D1%82%D0%BE%D1%81%D1%82%D1%8C-%D0%BE%D0%B1%D0%BE%D1%80%D1%83%D0%B4%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/17744048663181-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%97%D0%B0%D0%BD%D1%8F%D1%82%D0%BE%D1%81%D1%82%D1%8C-%D0%BE%D0%B1%D0%BE%D1%80%D1%83%D0%B4%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/17744048663181-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%97%D0%B0%D0%BD%D1%8F%D1%82%D0%BE%D1%81%D1%82%D1%8C-%D0%BE%D0%B1%D0%BE%D1%80%D1%83%D0%B4%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/17744048663181-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%97%D0%B0%D0%BD%D1%8F%D1%82%D0%BE%D1%81%D1%82%D1%8C-%D0%BE%D0%B1%D0%BE%D1%80%D1%83%D0%B4%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/17744048663181-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%97%D0%B0%D0%BD%D1%8F%D1%82%D0%BE%D1%81%D1%82%D1%8C-%D0%BE%D0%B1%D0%BE%D1%80%D1%83%D0%B4%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/17744048663181-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%97%D0%B0%D0%BD%D1%8F%D1%82%D0%BE%D1%81%D1%82%D1%8C-%D0%BE%D0%B1%D0%BE%D1%80%D1%83%D0%B4%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/17744048663181-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%97%D0%B0%D0%BD%D1%8F%D1%82%D0%BE%D1%81%D1%82%D1%8C-%D0%BE%D0%B1%D0%BE%D1%80%D1%83%D0%B4%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/17744048663181-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%97%D0%B0%D0%BD%D1%8F%D1%82%D0%BE%D1%81%D1%82%D1%8C-%D0%BE%D0%B1%D0%BE%D1%80%D1%83%D0%B4%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/17744048663181-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%97%D0%B0%D0%BD%D1%8F%D1%82%D0%BE%D1%81%D1%82%D1%8C-%D0%BE%D0%B1%D0%BE%D1%80%D1%83%D0%B4%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/17744048663181-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%97%D0%B0%D0%BD%D1%8F%D1%82%D0%BE%D1%81%D1%82%D1%8C-%D0%BE%D0%B1%D0%BE%D1%80%D1%83%D0%B4%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/17744048663181-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%97%D0%B0%D0%BD%D1%8F%D1%82%D0%BE%D1%81%D1%82%D1%8C-%D0%BE%D0%B1%D0%BE%D1%80%D1%83%D0%B4%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/17744048663181-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%97%D0%B0%D0%BD%D1%8F%D1%82%D0%BE%D1%81%D1%82%D1%8C-%D0%BE%D0%B1%D0%BE%D1%80%D1%83%D0%B4%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F',
  },
  sales_report: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/18395654827917-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BF%D1%80%D0%BE%D0%B4%D0%B0%D0%B6%D0%B0%D0%BC',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/18395654827917-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BF%D1%80%D0%BE%D0%B4%D0%B0%D0%B6%D0%B0%D0%BC',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/18395654827917-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BF%D1%80%D0%BE%D0%B4%D0%B0%D0%B6%D0%B0%D0%BC',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/18395654827917-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BF%D1%80%D0%BE%D0%B4%D0%B0%D0%B6%D0%B0%D0%BC',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/18395654827917-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BF%D1%80%D0%BE%D0%B4%D0%B0%D0%B6%D0%B0%D0%BC',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/18395654827917-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BF%D1%80%D0%BE%D0%B4%D0%B0%D0%B6%D0%B0%D0%BC',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/18395654827917-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BF%D1%80%D0%BE%D0%B4%D0%B0%D0%B6%D0%B0%D0%BC',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/18395654827917-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BF%D1%80%D0%BE%D0%B4%D0%B0%D0%B6%D0%B0%D0%BC',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/18395654827917-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BF%D1%80%D0%BE%D0%B4%D0%B0%D0%B6%D0%B0%D0%BC',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/18395654827917-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BF%D1%80%D0%BE%D0%B4%D0%B0%D0%B6%D0%B0%D0%BC',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/18395654827917-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BF%D1%80%D0%BE%D0%B4%D0%B0%D0%B6%D0%B0%D0%BC',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/18395654827917-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BF%D1%80%D0%BE%D0%B4%D0%B0%D0%B6%D0%B0%D0%BC',
  },
  user_report: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/23681383415053-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0%D0%BC',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/23681383415053-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0%D0%BC',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/23681383415053-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0%D0%BC',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/23681383415053-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0%D0%BC',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/23681383415053-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0%D0%BC',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/23681383415053-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0%D0%BC',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/23681383415053-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0%D0%BC',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/23681383415053-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0%D0%BC',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/23681383415053-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0%D0%BC',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/23681383415053-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0%D0%BC',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/23681383415053-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0%D0%BC',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/23681383415053-%D0%9E%D1%82%D1%87%D0%B5%D1%82-%D0%BF%D0%BE-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0%D0%BC',
  },
  customizable_permissions: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/10935159225357',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/10935159225357',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/10935159225357',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/10935159225357',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/10935159225357',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/10935159225357',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/10935159225357',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/10935159225357',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/10935159225357',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/10935159225357',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/10935159225357',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/10935159225357',
  },
  smart_bonus: {
    [ELanguage.RU]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.KK]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.UZ]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.KY]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.AZ]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.EN]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.VI]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.ES]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.PT]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.FR]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.TR]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.DE]: 'https://support.smartshell.gg/hc/en-us',
  },
  post_payments: {
    [ELanguage.RU]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.KK]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.UZ]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.KY]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.AZ]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.EN]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.VI]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.ES]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.PT]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.FR]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.TR]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.DE]: 'https://support.smartshell.gg/hc/en-us',
  },
  cash_order_tooltip: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/12124640047629-%D0%9E%D1%88%D0%B8%D0%B1%D0%BA%D0%B8-%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D1%8B-%D0%9A%D0%9A%D0%A2',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/12124640047629-%D0%9E%D1%88%D0%B8%D0%B1%D0%BA%D0%B8-%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D1%8B-%D0%9A%D0%9A%D0%A2',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/12124640047629-%D0%9E%D1%88%D0%B8%D0%B1%D0%BA%D0%B8-%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D1%8B-%D0%9A%D0%9A%D0%A2',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/12124640047629-%D0%9E%D1%88%D0%B8%D0%B1%D0%BA%D0%B8-%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D1%8B-%D0%9A%D0%9A%D0%A2',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/12124640047629-%D0%9E%D1%88%D0%B8%D0%B1%D0%BA%D0%B8-%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D1%8B-%D0%9A%D0%9A%D0%A2',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/12124640047629-%D0%9E%D1%88%D0%B8%D0%B1%D0%BA%D0%B8-%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D1%8B-%D0%9A%D0%9A%D0%A2',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/12124640047629-%D0%9E%D1%88%D0%B8%D0%B1%D0%BA%D0%B8-%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D1%8B-%D0%9A%D0%9A%D0%A2',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/12124640047629-%D0%9E%D1%88%D0%B8%D0%B1%D0%BA%D0%B8-%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D1%8B-%D0%9A%D0%9A%D0%A2',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/12124640047629-%D0%9E%D1%88%D0%B8%D0%B1%D0%BA%D0%B8-%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D1%8B-%D0%9A%D0%9A%D0%A2',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/12124640047629-%D0%9E%D1%88%D0%B8%D0%B1%D0%BA%D0%B8-%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D1%8B-%D0%9A%D0%9A%D0%A2',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/12124640047629-%D0%9E%D1%88%D0%B8%D0%B1%D0%BA%D0%B8-%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D1%8B-%D0%9A%D0%9A%D0%A2',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/12124640047629-%D0%9E%D1%88%D0%B8%D0%B1%D0%BA%D0%B8-%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D1%8B-%D0%9A%D0%9A%D0%A2',
  },
  sbp_tinkoff: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/29533517437197-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D1%8B-%D0%B8%D0%B7-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D0%B8-%D0%BC%D0%BE%D0%B1%D0%B8%D0%BB%D1%8C%D0%BD%D0%BE%D0%B3%D0%BE-%D0%BF%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-%D0%A1%D0%91%D0%9F',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/29533517437197-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D1%8B-%D0%B8%D0%B7-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D0%B8-%D0%BC%D0%BE%D0%B1%D0%B8%D0%BB%D1%8C%D0%BD%D0%BE%D0%B3%D0%BE-%D0%BF%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-%D0%A1%D0%91%D0%9F',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/29533517437197-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D1%8B-%D0%B8%D0%B7-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D0%B8-%D0%BC%D0%BE%D0%B1%D0%B8%D0%BB%D1%8C%D0%BD%D0%BE%D0%B3%D0%BE-%D0%BF%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-%D0%A1%D0%91%D0%9F',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/29533517437197-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D1%8B-%D0%B8%D0%B7-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D0%B8-%D0%BC%D0%BE%D0%B1%D0%B8%D0%BB%D1%8C%D0%BD%D0%BE%D0%B3%D0%BE-%D0%BF%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-%D0%A1%D0%91%D0%9F',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/29533517437197-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D1%8B-%D0%B8%D0%B7-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D0%B8-%D0%BC%D0%BE%D0%B1%D0%B8%D0%BB%D1%8C%D0%BD%D0%BE%D0%B3%D0%BE-%D0%BF%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-%D0%A1%D0%91%D0%9F',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/29533517437197-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D1%8B-%D0%B8%D0%B7-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D0%B8-%D0%BC%D0%BE%D0%B1%D0%B8%D0%BB%D1%8C%D0%BD%D0%BE%D0%B3%D0%BE-%D0%BF%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-%D0%A1%D0%91%D0%9F',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/29533517437197-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D1%8B-%D0%B8%D0%B7-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D0%B8-%D0%BC%D0%BE%D0%B1%D0%B8%D0%BB%D1%8C%D0%BD%D0%BE%D0%B3%D0%BE-%D0%BF%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-%D0%A1%D0%91%D0%9F',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/29533517437197-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D1%8B-%D0%B8%D0%B7-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D0%B8-%D0%BC%D0%BE%D0%B1%D0%B8%D0%BB%D1%8C%D0%BD%D0%BE%D0%B3%D0%BE-%D0%BF%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-%D0%A1%D0%91%D0%9F',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/29533517437197-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D1%8B-%D0%B8%D0%B7-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D0%B8-%D0%BC%D0%BE%D0%B1%D0%B8%D0%BB%D1%8C%D0%BD%D0%BE%D0%B3%D0%BE-%D0%BF%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-%D0%A1%D0%91%D0%9F',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/29533517437197-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D1%8B-%D0%B8%D0%B7-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D0%B8-%D0%BC%D0%BE%D0%B1%D0%B8%D0%BB%D1%8C%D0%BD%D0%BE%D0%B3%D0%BE-%D0%BF%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-%D0%A1%D0%91%D0%9F',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/29533517437197-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D1%8B-%D0%B8%D0%B7-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D0%B8-%D0%BC%D0%BE%D0%B1%D0%B8%D0%BB%D1%8C%D0%BD%D0%BE%D0%B3%D0%BE-%D0%BF%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-%D0%A1%D0%91%D0%9F',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/29533517437197-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D1%8B-%D0%B8%D0%B7-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D0%B8-%D0%BC%D0%BE%D0%B1%D0%B8%D0%BB%D1%8C%D0%BD%D0%BE%D0%B3%D0%BE-%D0%BF%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-%D0%A1%D0%91%D0%9F',
  },
  cloudPayments: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/21316643204365-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-CloudPayments',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/21316643204365-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-CloudPayments',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/21316643204365-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-CloudPayments',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/21316643204365-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-CloudPayments',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/21316643204365-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-CloudPayments',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/21316643204365-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-CloudPayments',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/21316643204365-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-CloudPayments',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/21316643204365-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-CloudPayments',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/21316643204365-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-CloudPayments',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/21316643204365-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-CloudPayments',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/21316643204365-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-CloudPayments',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/21316643204365-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-CloudPayments',
  },
  kaspi_POS: {
    [ELanguage.RU]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.KK]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.UZ]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.KY]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.AZ]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.EN]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.VI]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.ES]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.PT]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.FR]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.TR]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.DE]: 'https://support.smartshell.gg/hc/en-us',
  },
  kaspi_online: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/34028386094861-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-Kaspi-QR',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/34028386094861-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-Kaspi-QR',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/34028386094861-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-Kaspi-QR',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/34028386094861-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-Kaspi-QR',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/34028386094861-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-Kaspi-QR',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/34028386094861-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-Kaspi-QR',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/34028386094861-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-Kaspi-QR',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/34028386094861-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-Kaspi-QR',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/34028386094861-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-Kaspi-QR',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/34028386094861-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-Kaspi-QR',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/34028386094861-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-Kaspi-QR',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/34028386094861-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-Kaspi-QR',
  },
  stripe: {
    [ELanguage.RU]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.KK]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.UZ]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.KY]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.AZ]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.EN]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.VI]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.ES]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.PT]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.FR]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.TR]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.DE]: 'https://support.smartshell.gg/hc/en-us',
  },
  home: {
    [ELanguage.RU]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.KK]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.UZ]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.KY]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.AZ]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.EN]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.VI]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.ES]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.PT]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.FR]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.TR]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.DE]: 'https://support.smartshell.gg/hc/en-us',
  },
  subscription: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/11288704170253',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/11288704170253',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/11288704170253',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/11288704170253',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/11288704170253',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/11288704170253',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/11288704170253',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/11288704170253',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/11288704170253',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/11288704170253',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/11288704170253',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/11288704170253',
  },
  shell_settings: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/17927625338125-%D0%9D%D0%B0%D1%81%D1%82%D1%80%D0%BE%D0%B9%D0%BA%D0%B8-%D0%A8%D0%B5%D0%BB%D0%BB',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/17927625338125-%D0%9D%D0%B0%D1%81%D1%82%D1%80%D0%BE%D0%B9%D0%BA%D0%B8-%D0%A8%D0%B5%D0%BB%D0%BB',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/17927625338125-%D0%9D%D0%B0%D1%81%D1%82%D1%80%D0%BE%D0%B9%D0%BA%D0%B8-%D0%A8%D0%B5%D0%BB%D0%BB',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/17927625338125-%D0%9D%D0%B0%D1%81%D1%82%D1%80%D0%BE%D0%B9%D0%BA%D0%B8-%D0%A8%D0%B5%D0%BB%D0%BB',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/17927625338125-%D0%9D%D0%B0%D1%81%D1%82%D1%80%D0%BE%D0%B9%D0%BA%D0%B8-%D0%A8%D0%B5%D0%BB%D0%BB',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/17927625338125-%D0%9D%D0%B0%D1%81%D1%82%D1%80%D0%BE%D0%B9%D0%BA%D0%B8-%D0%A8%D0%B5%D0%BB%D0%BB',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/17927625338125-%D0%9D%D0%B0%D1%81%D1%82%D1%80%D0%BE%D0%B9%D0%BA%D0%B8-%D0%A8%D0%B5%D0%BB%D0%BB',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/17927625338125-%D0%9D%D0%B0%D1%81%D1%82%D1%80%D0%BE%D0%B9%D0%BA%D0%B8-%D0%A8%D0%B5%D0%BB%D0%BB',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/17927625338125-%D0%9D%D0%B0%D1%81%D1%82%D1%80%D0%BE%D0%B9%D0%BA%D0%B8-%D0%A8%D0%B5%D0%BB%D0%BB',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/17927625338125-%D0%9D%D0%B0%D1%81%D1%82%D1%80%D0%BE%D0%B9%D0%BA%D0%B8-%D0%A8%D0%B5%D0%BB%D0%BB',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/17927625338125-%D0%9D%D0%B0%D1%81%D1%82%D1%80%D0%BE%D0%B9%D0%BA%D0%B8-%D0%A8%D0%B5%D0%BB%D0%BB',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/17927625338125-%D0%9D%D0%B0%D1%81%D1%82%D1%80%D0%BE%D0%B9%D0%BA%D0%B8-%D0%A8%D0%B5%D0%BB%D0%BB',
  },
  post_payment: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/31719635457677-%D0%9F%D0%BE%D1%81%D1%82%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D0%B0',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/31719635457677-%D0%9F%D0%BE%D1%81%D1%82%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D0%B0',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/31719635457677-%D0%9F%D0%BE%D1%81%D1%82%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D0%B0',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/31719635457677-%D0%9F%D0%BE%D1%81%D1%82%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D0%B0',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/31719635457677-%D0%9F%D0%BE%D1%81%D1%82%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D0%B0',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/31719635457677-%D0%9F%D0%BE%D1%81%D1%82%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D0%B0',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/31719635457677-%D0%9F%D0%BE%D1%81%D1%82%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D0%B0',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/31719635457677-%D0%9F%D0%BE%D1%81%D1%82%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D0%B0',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/31719635457677-%D0%9F%D0%BE%D1%81%D1%82%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D0%B0',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/31719635457677-%D0%9F%D0%BE%D1%81%D1%82%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D0%B0',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/31719635457677-%D0%9F%D0%BE%D1%81%D1%82%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D0%B0',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/31719635457677-%D0%9F%D0%BE%D1%81%D1%82%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D0%B0',
  },
  application: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/10935173795213-%D0%9F%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F#h_01GJWQ777JXD9ZFYJ4WPPBGPSF',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/10935173795213-%D0%9F%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F#h_01GJWQ777JXD9ZFYJ4WPPBGPSF',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/10935173795213-%D0%9F%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F#h_01GJWQ777JXD9ZFYJ4WPPBGPSF',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/10935173795213-%D0%9F%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F#h_01GJWQ777JXD9ZFYJ4WPPBGPSF',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/10935173795213-%D0%9F%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F#h_01GJWQ777JXD9ZFYJ4WPPBGPSF',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/10935173795213-%D0%9F%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F#h_01GJWQ777JXD9ZFYJ4WPPBGPSF',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/10935173795213-%D0%9F%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F#h_01GJWQ777JXD9ZFYJ4WPPBGPSF',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/10935173795213-%D0%9F%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F#h_01GJWQ777JXD9ZFYJ4WPPBGPSF',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/10935173795213-%D0%9F%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F#h_01GJWQ777JXD9ZFYJ4WPPBGPSF',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/10935173795213-%D0%9F%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F#h_01GJWQ777JXD9ZFYJ4WPPBGPSF',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/10935173795213-%D0%9F%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F#h_01GJWQ777JXD9ZFYJ4WPPBGPSF',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/10935173795213-%D0%9F%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F#h_01GJWQ777JXD9ZFYJ4WPPBGPSF',
  },
  shell_download: {
    [ELanguage.RU]:
      'https://support.smartshell.gg/hc/ru/articles/15783030445709-%D0%A8%D0%B0%D0%B3-3-%D0%A3%D1%81%D1%82%D0%B0%D0%BD%D0%BE%D0%B2%D0%BA%D0%B0-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D1%8F-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0-%D1%81%D0%BE%D0%B7%D0%B4%D0%B0%D0%BD%D0%B8%D0%B5-%D1%81%D0%BE%D1%82%D1%80%D1%83%D0%B4%D0%BD%D0%B8%D0%BA%D0%BE%D0%B2',
    [ELanguage.KK]:
      'https://support.smartshell.gg/hc/ru/articles/15783030445709-%D0%A8%D0%B0%D0%B3-3-%D0%A3%D1%81%D1%82%D0%B0%D0%BD%D0%BE%D0%B2%D0%BA%D0%B0-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D1%8F-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0-%D1%81%D0%BE%D0%B7%D0%B4%D0%B0%D0%BD%D0%B8%D0%B5-%D1%81%D0%BE%D1%82%D1%80%D1%83%D0%B4%D0%BD%D0%B8%D0%BA%D0%BE%D0%B2',
    [ELanguage.UZ]:
      'https://support.smartshell.gg/hc/ru/articles/15783030445709-%D0%A8%D0%B0%D0%B3-3-%D0%A3%D1%81%D1%82%D0%B0%D0%BD%D0%BE%D0%B2%D0%BA%D0%B0-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D1%8F-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0-%D1%81%D0%BE%D0%B7%D0%B4%D0%B0%D0%BD%D0%B8%D0%B5-%D1%81%D0%BE%D1%82%D1%80%D1%83%D0%B4%D0%BD%D0%B8%D0%BA%D0%BE%D0%B2',
    [ELanguage.KY]:
      'https://support.smartshell.gg/hc/ru/articles/15783030445709-%D0%A8%D0%B0%D0%B3-3-%D0%A3%D1%81%D1%82%D0%B0%D0%BD%D0%BE%D0%B2%D0%BA%D0%B0-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D1%8F-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0-%D1%81%D0%BE%D0%B7%D0%B4%D0%B0%D0%BD%D0%B8%D0%B5-%D1%81%D0%BE%D1%82%D1%80%D1%83%D0%B4%D0%BD%D0%B8%D0%BA%D0%BE%D0%B2',
    [ELanguage.AZ]:
      'https://support.smartshell.gg/hc/ru/articles/15783030445709-%D0%A8%D0%B0%D0%B3-3-%D0%A3%D1%81%D1%82%D0%B0%D0%BD%D0%BE%D0%B2%D0%BA%D0%B0-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D1%8F-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0-%D1%81%D0%BE%D0%B7%D0%B4%D0%B0%D0%BD%D0%B8%D0%B5-%D1%81%D0%BE%D1%82%D1%80%D1%83%D0%B4%D0%BD%D0%B8%D0%BA%D0%BE%D0%B2',
    [ELanguage.EN]:
      'https://support.smartshell.gg/hc/en-us/articles/15783030445709-%D0%A8%D0%B0%D0%B3-3-%D0%A3%D1%81%D1%82%D0%B0%D0%BD%D0%BE%D0%B2%D0%BA%D0%B0-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D1%8F-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0-%D1%81%D0%BE%D0%B7%D0%B4%D0%B0%D0%BD%D0%B8%D0%B5-%D1%81%D0%BE%D1%82%D1%80%D1%83%D0%B4%D0%BD%D0%B8%D0%BA%D0%BE%D0%B2',
    [ELanguage.VI]:
      'https://support.smartshell.gg/hc/en-us/articles/15783030445709-%D0%A8%D0%B0%D0%B3-3-%D0%A3%D1%81%D1%82%D0%B0%D0%BD%D0%BE%D0%B2%D0%BA%D0%B0-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D1%8F-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0-%D1%81%D0%BE%D0%B7%D0%B4%D0%B0%D0%BD%D0%B8%D0%B5-%D1%81%D0%BE%D1%82%D1%80%D1%83%D0%B4%D0%BD%D0%B8%D0%BA%D0%BE%D0%B2',
    [ELanguage.ES]:
      'https://support.smartshell.gg/hc/en-us/articles/15783030445709-%D0%A8%D0%B0%D0%B3-3-%D0%A3%D1%81%D1%82%D0%B0%D0%BD%D0%BE%D0%B2%D0%BA%D0%B0-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D1%8F-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0-%D1%81%D0%BE%D0%B7%D0%B4%D0%B0%D0%BD%D0%B8%D0%B5-%D1%81%D0%BE%D1%82%D1%80%D1%83%D0%B4%D0%BD%D0%B8%D0%BA%D0%BE%D0%B2',
    [ELanguage.PT]:
      'https://support.smartshell.gg/hc/en-us/articles/15783030445709-%D0%A8%D0%B0%D0%B3-3-%D0%A3%D1%81%D1%82%D0%B0%D0%BD%D0%BE%D0%B2%D0%BA%D0%B0-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D1%8F-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0-%D1%81%D0%BE%D0%B7%D0%B4%D0%B0%D0%BD%D0%B8%D0%B5-%D1%81%D0%BE%D1%82%D1%80%D1%83%D0%B4%D0%BD%D0%B8%D0%BA%D0%BE%D0%B2',
    [ELanguage.FR]:
      'https://support.smartshell.gg/hc/en-us/articles/15783030445709-%D0%A8%D0%B0%D0%B3-3-%D0%A3%D1%81%D1%82%D0%B0%D0%BD%D0%BE%D0%B2%D0%BA%D0%B0-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D1%8F-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0-%D1%81%D0%BE%D0%B7%D0%B4%D0%B0%D0%BD%D0%B8%D0%B5-%D1%81%D0%BE%D1%82%D1%80%D1%83%D0%B4%D0%BD%D0%B8%D0%BA%D0%BE%D0%B2',
    [ELanguage.TR]:
      'https://support.smartshell.gg/hc/en-us/articles/15783030445709-%D0%A8%D0%B0%D0%B3-3-%D0%A3%D1%81%D1%82%D0%B0%D0%BD%D0%BE%D0%B2%D0%BA%D0%B0-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D1%8F-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0-%D1%81%D0%BE%D0%B7%D0%B4%D0%B0%D0%BD%D0%B8%D0%B5-%D1%81%D0%BE%D1%82%D1%80%D1%83%D0%B4%D0%BD%D0%B8%D0%BA%D0%BE%D0%B2',
    [ELanguage.DE]:
      'https://support.smartshell.gg/hc/en-us/articles/15783030445709-%D0%A8%D0%B0%D0%B3-3-%D0%A3%D1%81%D1%82%D0%B0%D0%BD%D0%BE%D0%B2%D0%BA%D0%B0-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D1%8F-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0-%D1%81%D0%BE%D0%B7%D0%B4%D0%B0%D0%BD%D0%B8%D0%B5-%D1%81%D0%BE%D1%82%D1%80%D1%83%D0%B4%D0%BD%D0%B8%D0%BA%D0%BE%D0%B2',
  },
  BePaid: {
    [ELanguage.RU]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.KK]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.UZ]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.KY]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.AZ]: 'https://support.smartshell.gg/hc/ru',
    [ELanguage.EN]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.VI]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.ES]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.PT]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.FR]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.TR]: 'https://support.smartshell.gg/hc/en-us',
    [ELanguage.DE]: 'https://support.smartshell.gg/hc/en-us',
  },
};
